export const FETCH_HOME_DETAILS_BEGIN = 'FETCH_HOME_DETAILS_BEGIN';
export const FETCH_HOME_DETAILS_SUCCESS = 'FETCH_HOME_DETAILS_SUCCESS';
export const FETCH_HOME_DETAILS_FAILURE = 'FETCH_HOME_DETAILS_FAILURE';
export const FETCH_COMMON_DETAILS_BEGIN = 'FETCH_COMMON_DETAILS_BEGIN';
export const FETCH_COMMON_DETAILS_SUCCESS = 'FETCH_COMMON_DETAILS_SUCCESS';
export const FETCH_COMMON_DETAILS_FAILURE = 'FETCH_COMMON_DETAILS_FAILURE';